import { AxiosError } from "axios";
import { CustomError } from "../types/custom-error";

export const errorTransform = (
  axiosError: AxiosError<any>,
  unexpectedErrorText: string
) => {
  let error: CustomError = {
    message: unexpectedErrorText,
  };
  error = {
    message: axiosError.response?.data?.message ?? unexpectedErrorText,
  };

  return error;
};
